<oe-flat-widget [title]="'GENERAL.PRODUCTION' | translate" [icon]="{name: 'oe-production', color: 'production'}"
  [modalComponent]="modalComponent">
  @for (component of productionMeterComponents; track component; let i = $index) {
    <oe-flat-widget-line [name]="component.alias" [channelAddress]="component.id + '/ActivePower'"
      [converter]="CONVERT_WATT_TO_KILOWATT">
    </oe-flat-widget-line>
  }
  @for (component of chargerComponents; track component) {
    <oe-flat-widget-line [name]="component.alias" [channelAddress]="component.id + '/ActualPower'"
      [converter]="CONVERT_WATT_TO_KILOWATT">
    </oe-flat-widget-line>
  }
</oe-flat-widget>